import {queries} from '@/shared/integrations/zero'
import {useQuery} from '@rocicorp/zero/react'

export function useGetPatientEncounter(id: string | undefined) {
  return useQuery(queries.patients.getPatientLatestEncounter(id || ''))
}
